import { useFormContext, CheckboxField } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { selectById, useFetchCalendarAccountsQuery } from 'features/calendar_connections/api'

import { Label } from '../elements'
import { Option } from './option'
import { usePullCalendarsLimit, LimitDescription } from './use_pull_calendars_limit'

const pullCalendarIdsFieldName = 'pullCalendarIds'

const getLabel = (name, isHidden) => (isHidden
  ? `${name}${I18n.t('publisher.calendar.configuration.pull.popup.hidden_label')}`
  : name)

export const PullCalendars = ({ id }) => {
  const { data } = useFetchCalendarAccountsQuery()
  const { kind, calendars, canCheckForConflicts } = selectById(data, id)
  const [isLimited, isFieldDisabled, maxSubCalendars] = usePullCalendarsLimit(kind, pullCalendarIdsFieldName)
  const { values: { pullCalendarIds } } = useFormContext()

  if (!canCheckForConflicts) return I18n.t('publisher.calendar.outlook_desktop.select_calendars_instruction')

  const missingPullCalendarIds = pullCalendarIds.filter((pullCalendarId) => !calendars.some((calendar) => calendar.id === pullCalendarId))

  return (
    <>
      <Label>
        {I18n.t('publisher.calendar.configuration.pull.popup.label')}
      </Label>
      {isLimited && (
        <LimitDescription>
          {I18n.t('publisher.calendar.configuration.pull.popup.limit', { max: maxSubCalendars })}
        </LimitDescription>
      )}
      {
        calendars.map(({ id: calendarId, name, hidden }) => (
          <Option key={calendarId}>
            <CheckboxField
              name={pullCalendarIdsFieldName}
              label={getLabel(name, hidden)}
              value={calendarId}
              disabled={isFieldDisabled(calendarId)}
            />
          </Option>
        ))
      }
      {
        missingPullCalendarIds.map((missingPullCalendarId) => (
          <Option key={missingPullCalendarId}>
            <CheckboxField
              name={pullCalendarIdsFieldName}
              label={`${missingPullCalendarId}${I18n.t('publisher.calendar.configuration.pull.popup.unsubscribed_label')}`}
              value={missingPullCalendarId}
              disabled={isFieldDisabled(missingPullCalendarId)}
            />
          </Option>
        ))
      }
    </>
  )
}
